import { createStyles } from '@mantine/core'

export default createStyles((theme, _params, getRef) => ({
  root: {
    display: 'flex',
    minWidth: '30px',
    height: '30px',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '15px',
    fontWeight: 700,
    paddingLeft: '5px',
    paddingRight: '5px',
    borderRadius: '1000px',
    color: theme.white,
    backgroundColor: theme.colors[theme.primaryColor][theme.fn.primaryShade()],
    whiteSpace: 'nowrap',
  },

  active: {
    color: theme.colors[theme.primaryColor][theme.fn.primaryShade()],
    backgroundColor: theme.white,
  },
}))
